import { isNil } from 'lodash-es'
import { useLocale, useTranslations } from 'next-intl'

import { TSearchRoom } from '@/entities/map'
import { cn, useFormatCurrency } from '@/shared/lib'

export type Props = Partial<Pick<TSearchRoom, 'usingFee' | 'mgmtFee'>>

export const MobilePriceDetail = ({ usingFee, mgmtFee }: Props) => {
  const locale = useLocale()

  const { formatCurrency } = useFormatCurrency()

  const t = useTranslations('common')

  const isEnglish = locale === 'en'

  if (isNil(usingFee) || isNil(mgmtFee)) return null

  return (
    <div className="typo-caption1 flex items-center gap-2 font-normal text-gray-500 not-last:mb-2">
      <p className={cn('flex shrink-0 items-center', isEnglish && 'gap-1')}>
        <span className={cn('inline-block w-8.5', isEnglish && 'w-fit')}>
          {t('rent')}
        </span>
        <span className="text-gray-900">{formatCurrency(usingFee)}</span>
      </p>
      <p
        className={cn(
          'flex shrink-0 items-center',
          isEnglish && 'shrink gap-1',
        )}
      >
        <span className={cn('inline-block w-8.5', isEnglish && 'w-fit')}>
          {t('utility_fee')}
        </span>
        <span className="text-gray-900">{formatCurrency(mgmtFee)}</span>
      </p>
    </div>
  )
}
